import React, {useEffect} from 'react';
import {Breadcrumb, Card, PageHeader} from 'antd';
import QuickRouter from '../../../utils/QuickRouter';
import CollectionWorkProjectSubmitForm from '../../../components/CollectionWorkProject/SubmitForm';
import Flex from '../../../components/Flex';
import useCollectionWork from '../../../hooks/apis/useCollectionWork';
import CollectionWorkProjectRecordList from '../../../components/CollectionWorkProjectRecord/List';
import {UserType} from '../../../hooks/apis/useUser';
import CustomerError from '../../../components/CustomerError';
import useQuickRouter from '../../../utils/QuickRouter';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useAuth from '../../../utils/AuthContext';
import {useParams} from 'react-router-dom';

export default function CollectionWorkMyRecordPage() {
  const params = useParams() as {id?: string};
  const collectionWorkId = parseInt(params.id as string);
  const queryByIdHook = useCollectionWork.queryById();
  const quickRouter = useQuickRouter();

  function refresh() {
    queryByIdHook
      .request({id: collectionWorkId})
      .then()
      .catch(CommonApiErrorHandler);
  }
  useEffect(() => {
    if (collectionWorkId) {
      refresh();
    }
  }, [collectionWorkId]);
  const auth = useAuth();
  if (!auth.currentUser || auth.currentUser.type !== UserType.普通账号) return <CustomerError title={'无操作权限'} />;

  return (
    <Flex justify={'center'}>
      <div style={{width: 800}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(queryByIdHook.data?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card style={{margin: 20}} bodyStyle={{padding: 0}}>
          <CollectionWorkProjectRecordList collectionWorkId={collectionWorkId} onFinish={refresh} />
        </Card>
      </div>
    </Flex>
  );
}
